import { IErrorResponseType } from "../../constants/commonTypes";
import { TncState } from "../reducers/tncReducer";

export const SUBMIT_TNC_CONSENT = "SUBMIT_TNC_CONSENT"
export const SUBMIT_TNC_CONSENT_REQUEST = "SUBMIT_TNC_CONSENT_REQUEST"
export const SUBMIT_TNC_CONSENT_FAILURE = "SUBMIT_TNC_CONSENT_FAILURE"
export const SUBMIT_TNC_CONSENT_SUCCESS = "SUBMIT_TNC_CONSENT_SUCCESS"

export const GET_TNC = "GET_TNC"
export const GET_TNC_REQUEST = "GET_TNC_REQUEST"
export const GET_TNC_FAILURE = "GET_TNC_FAILURE"
export const GET_TNC_SUCCESS = "GET_TNC_SUCCESS"


export interface SubmitTncConsentAction {
  type: typeof SUBMIT_TNC_CONSENT;
  request: object;
}

export interface SubmitTncConsentRequestAction {
  type: typeof SUBMIT_TNC_CONSENT_REQUEST;
}

export interface SubmitTncConsentSuccessAction {
  type: typeof SUBMIT_TNC_CONSENT_SUCCESS;
  response: TncState;
}

export interface SubmitTncConsentFailureAction {
  type: typeof SUBMIT_TNC_CONSENT_FAILURE;
  error: Error | string | null | IErrorResponseType;
}

export interface GetTncAction {
  type: typeof GET_TNC;
}

export interface GetTncRequestAction {
  type: typeof GET_TNC_REQUEST;
}

export interface GetTncSuccessAction {
  type: typeof GET_TNC_SUCCESS;
  response: TncState;
}

export interface GetTncFailureAction {
  type: typeof GET_TNC_FAILURE;
  error: Error | string | null | IErrorResponseType;
}

export type TncActions =
  | SubmitTncConsentAction
  | SubmitTncConsentRequestAction
  | SubmitTncConsentSuccessAction
  | SubmitTncConsentFailureAction
  | GetTncAction
  | GetTncRequestAction
  | GetTncSuccessAction
  | GetTncFailureAction;